import z from "zod";
export const DTOMCPUsageStatsResponse = z.object({
    mcpConsumerCount: z.number(),
});
